import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useRef, useCallback } from 'react';
import { ApiCalls } from '../../../api/api';
import { INTEGRATIONS_SETTINGS } from '../../../constants/queryKeys';
import { useMemoQueryKey } from '../../useMemoQueryKey';
import { IntegrationTypeGeneric } from '../../../Configuration/config/components/integrationsv2/IntegrationTypeGeneric';

export const useIntegrations = () => {
    const defaultData = useRef([] as IntegrationTypeGeneric<any, any>[]).current;
    const qKey = useMemoQueryKey(INTEGRATIONS_SETTINGS);
    const { data: integrations = defaultData, isLoading } = useQuery({
        queryKey: qKey,
        queryFn: async () => ApiCalls.integrationEventList().then(res => res.data),
    });
    const queryClient = useQueryClient();
    const updateIntegrations = useCallback(
        (updater: IntegrationTypeGeneric<any, any>[] | ((data: IntegrationTypeGeneric<any, any>[]) => IntegrationTypeGeneric<any, any>[])) => {
            queryClient.setQueryData<IntegrationTypeGeneric<any, any>[]>(qKey, typeof updater === 'function' ? updater : () => updater);
        },
        [qKey, queryClient],
    );

    return { integrations, isLoading, updateIntegrations };
};
